import { useHistory } from '@fs/zion-router'

const useReferrer = () => {
  const history = useHistory()

  return `/tree-designs${history?.location?.pathname}`
}

export default useReferrer
